import { render } from "./PageNav.vue?vue&type=template&id=e2ec0d62"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/PageNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2ec0d62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2ec0d62', __exports__)) {
    api.reload('e2ec0d62', __exports__)
  }
  
  module.hot.accept("./PageNav.vue?vue&type=template&id=e2ec0d62", () => {
    api.rerender('e2ec0d62', render)
  })

}


export default __exports__